import React from "react";

import View						from "../common/components/layouts/View";
import Content					from "../common/components/layouts/Content";
import FAQ	from "../faq";


import HeaderContainer from "../app/HeaderContainer";
import ConfirmationContainer from "./ConfirmationContainer";

export default class extends React.Component {
	render() {
		return (
			<div className="confirmation">
				<ConfirmationContainer {...this.props} />
					<div className="confirmation__help-wrapper">
						<FAQ />
					</div>
					<footer className="confirm-footer">
						<p>
							Un outil pour créer vos organigrammes par
							<img className="auth__brand-logo" src={require("../../assets/legallais.png")} />
						</p>
					</footer>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/confirmation/index.js